/*
 * 商品属性module
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 20:20:31
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2020-01-08 15:17:46
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route exact path= {`${match.url}`} component={Main} />
		</Switch>
	);
};
